const { Fragment, useEffect, useState } = wp.element;
import { __ } from "@wordpress/i18n";

import Settings from "./Settings";

function Edit(props) {
  const { attributes } = props;
  const {
    data: { tringle_text },
  } = attributes;
  // wp.data.dispatch("core/edit-post").hideBlockTypes(["pdp/podcast"]);
  const [data, setData] = useState({});

  useEffect(() => {
    jQuery.get(pdfp?.siteUrl + "/wp-json/pdfposter/v1/single/" + tringle_text, function (res) {
      setData(res);
    });
  }, [attributes]);

  const {
    file = pdfp?.placeholder,
    title,
    titleFontSize,
    height = "1122px",
    width = "100%",
    showName,
    print,
    onlyPDF,
    downloadButton,
    downloadButtonText,
    fullscreenButton,
    fullscreenButtonText,
    protect,
    thumbMenu,
    initialPage,
  } = data;

  const source = `${pdfp?.dir}pdfjs/web/${protect ? "pviewer.php" : "viewer.php"}?file=${file}&nobaki=${!protect && downloadButton ? "vera" : "false"}&stdono=${
    print && !protect ? "vera" : "false"
  }&open=false&onlypdf=${onlyPDF ? "vera" : "false"}&side=${thumbMenu}#page=${initialPage}`;

  return (
    <Fragment>
      <Settings props={props} />
      <div className={`pdfp_wrapper`} style={{ width }}>
        {showName && <p style={{ fontSize: titleFontSize }}>{title}</p>}
        <div className="cta_wrapper">
          {downloadButton && !protect && (
            <a className="pdfp_download" download href={file}>
              <button className="pdfp_download_btn">{downloadButtonText}</button>
            </a>
          )}
          {fullscreenButton && !protect && (
            <a href={source} target="_blank">
              <button>{fullscreenButtonText}</button>
            </a>
          )}
        </div>
        <div className="iframe_wrapper">
          <div className="pdfp_frame_overlay"></div>
          <iframe className="pdfp_iframe" height={height} style={{ height }} src={source}></iframe>
        </div>
      </div>
    </Fragment>
  );
}

export default Edit;
